'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from '@/lib/routing';
import { useOrderFormStore } from '@/lib/store/order-form-store';

export const ResetStoreOnNavigationGuard = () => {
  const initialPathname = useRef<string | null>(null);
  // CRITICAL FIX: Use specific selector
  const resetToDefault = useOrderFormStore.use.resetToDefault();
  const pathname = usePathname();

  useEffect(() => {
    if (!initialPathname.current) {
      initialPathname.current = pathname;
      return;
    }
    return () => {
      if (initialPathname.current !== pathname) {
        return;
      }
      resetToDefault();
    };
  }, [pathname, resetToDefault]);
  return null;
};
